import {
    reactive,
    onBeforeMount,
    watch,
  } from "@vue/composition-api";
  import router from "@/router";
  import store from "@/store";
  import { privilegeCodeTemplateModel } from "@/models/privilege/privilege-code-template";
  import usePagination from "@/views/components/pagination/usePagination";
  import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
  import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
  
  export default function useExportCodeHistory(props) {

    const WITHDRAW_STATUS_PREPAREING = 1
    const WITHDRAW_STATUS_PROGRESS = 2
    const WITHDRAW_STATUS_SUCCESS = 9
    const WITHDRAW_STATUS_ERROR = 11
    const WITHDRAW_STATUS_FAIL = 22
    
    const { pagination, onPageChange, onFilterEntity } = usePagination();
    const {
      filters,
      ordering,
      onSetValueSearch,
    } = useFilterHeaderTable();

    const {
      openDefaultErrorModal,
      openErrorModal,
      openSuccessModal,
      openWarningModal
    } = useValidationModal();

    const {
      getExportCodeHistoryList,
    } = privilegeCodeTemplateModel();

    const loading = reactive({
      tableData: false,
    });

    const fields = [
      { key: 'withdraw_id', label: 'Withdraw Id' },
      { key: 'withdraw', label: 'Export' },
      { key: 'fullfillment_mode_desc', label: 'Removal Strategy' },
      { key: 'updated_by_name', label: 'Updated By' },
      { key: 'starttime', label: 'Latest Update' },
      { key: 'progress', label: 'Progress' },
      { key: 'status_withdraw', label: 'Status' },
      { key: 'actions_export', label: '' },
    ];

    const exportCodeHistoryTable = reactive({
      payload: [],
    })

    const fetchExportCodeHistory = (showLoading = true, loadPrivilege = true) => {
      if (showLoading) {
        loading.tableData = true
      }
      let payload = {
        Template_Id: props.templateData.template_id,
        Page: pagination.currentPage,
        Limit: pagination.perPage,
        Filters: filters,
        Ordering: ordering.value,
      };
      getExportCodeHistoryList.payload = payload;
      store
        .dispatch('api/apiRequest', getExportCodeHistoryList)
        .then(response => {
          exportCodeHistoryTable.payload = response.data.paylaod
          pagination.rows = response.data.paylaod.length
          pagination.totalRows = response.data.filtered_record
        })
        .catch(error => {
          //3301001 - Code Template Export - not found
          if(error.data.error.code != 3301001)
          {
            openDefaultErrorModal(error)
          } 
        })
        .finally(() => {
          loading.tableData = false
        })
    }

    const exportFile = file => {
      if (!file) return
      window.location.href = file
    }

    const resolveExportStatusLabel = status => {
      switch (status) {
        case WITHDRAW_STATUS_PREPAREING:
          return 'Preparing'
        case WITHDRAW_STATUS_PROGRESS:
          return 'Progress'
        case WITHDRAW_STATUS_SUCCESS:
          return 'Complete'
        case WITHDRAW_STATUS_ERROR:
          return 'Error'
        case WITHDRAW_STATUS_FAIL:
          return 'Fail'
        default:
          return 'None'
      }
    }
  
    const resolveExportStatusClass = status => {
      switch (status) {
        case WITHDRAW_STATUS_PREPAREING:
          return '#FFB200'
        case WITHDRAW_STATUS_PROGRESS:
          return '#CDE6CD'
        case WITHDRAW_STATUS_SUCCESS:
          return '#00A400'
        case WITHDRAW_STATUS_ERROR:
          return '#B40000'
        case WITHDRAW_STATUS_FAIL:
          return '#B40000'
        default:
          return '#B40000'
      }
    }

    watch(
      pagination,
      () => {
        if (!loading.tableData) {
          fetchExportCodeHistory();
        }
      },
      { deep: true }
    );
  
    watch(
      [filters, ordering],
      () => {
        pagination.currentPage = 1;
  
        fetchExportCodeHistory();
      },
      { deep: true }
    );

    onBeforeMount(() => {
      fetchExportCodeHistory(true,true);
    });

    return{
      loading,
      fields,
      pagination,
      exportCodeHistoryTable,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      resolveExportStatusClass,
      resolveExportStatusLabel,
      exportFile,
    }
  }